export default __webpack_public_path__ + "static/media/infoIcon.32039a7b.svg";